import React, { useEffect, useState } from 'react';
import { Modal, Nav, Tab, Form, Button, Row, Col } from 'react-bootstrap';
import PropTypes from "prop-types";

const ModalFittings = ({ show, onHide, data, onSave, fittingData, fnComment, fnCommentValue }) => {
  const [selectedItems, setSelectedItems] = useState({});

  // Función para manejar la selección de checkbox
//   const handleCheckboxChange = (categoryId, itemId, isChecked) => {
//     setSelectedItems(prev => ({
//       ...prev,
//       [categoryId]: {
//         ...prev[categoryId],
//         [itemId]: isChecked
//       }
//     }));
//   };
  const handleCheckboxChange = (categoryId, itemId, isChecked) => {
    setSelectedItems(prev => {
      const newState = { ...prev };
      
      if (isChecked) {
        // Agregar el elemento
        newState[categoryId] = {
          ...newState[categoryId],
          [itemId]: {
            selected: true,
            quantity: 1
          }
        };
      } else {
        // Remover el elemento
        if (newState[categoryId]) {
          const updatedCategory = { ...newState[categoryId] };
          delete updatedCategory[itemId];
          
          // Si la categoría queda vacía, también eliminarla
          if (Object.keys(updatedCategory).length === 0) {
            delete newState[categoryId];
          } else {
            newState[categoryId] = updatedCategory;
          }
        }
      }
      
      return newState;
    });
  };

  // Función para obtener todos los items seleccionados
  const getSelectedItems = () => {
    const selected = [];
    Object.entries(selectedItems).forEach(([categoryId, items]) => {
      Object.entries(items).forEach(([itemId, isSelected]) => {
        if (isSelected) 
        {
          // Encontrar el item completo en el data
          const category = data.body.find(cat => cat.id === categoryId);
          const item = category?.values.find(val => val.id === itemId);
          if (item && Number(items[itemId].quantity) > 0) 
          {
            selected.push({
              categoryId,
              categoryName: category.name,
              itemId,
              itemValue: item.table_value,
              quantity: Number(items[itemId].quantity)
            });
          }
        }
      });
    });
    return selected;
  }; 

  const handleQuantityChange = (categoryId, itemId, quantity) => {
    setSelectedItems(prev => ({
        ...prev,
        [categoryId]: {
          ...prev[categoryId],
          [itemId]: {quantity: Number(quantity)}
        }
    }));
  };

  // Función para manejar el guardado
  const handleSave = () => {
    const selectedData = getSelectedItems();
    if (onSave) {
      onSave(selectedData);
      setSelectedItems({});//clear on selected
      fnComment("");
    }
    onHide();
  };

  // Función para limpiar selecciones al cerrar
  const handleClose = () => {
    setSelectedItems({});
    fnComment("");
    onHide();
  };

  // Función para transformar el array en objeto
  const transformArrayToObject = (selectedArray) => {
    const result = {};
    selectedArray.forEach(item => {
      let { categoryId, itemId, quantity } = item;      
      // Si la categoría no existe, crearla
      if (!result[categoryId]) {
        result[categoryId] = {};
      }
      
      // Agregar el item con su cantidad
      result[categoryId][itemId] = {
        quantity: quantity // Convertir a string como en tu ejemplo
      };
    });
    
    return result;
  };

  const getFittingSelected = () => {
    if ( fittingData !== null )
    {        
        const result = transformArrayToObject(fittingData.extraSelected);
        setSelectedItems(result)
    }
  }

  useEffect(()=>{
    if ( show )
        getFittingSelected()
  },[show])

  // Si no hay data, no mostrar el modal
  if (!data || !data.body) {
    return null;
  }

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Selección de adicionales ({data.description})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={styles.alert}>
        ℹ️ Siempre serán marcados los ultimos adicionales, en caso de no ver algun adicional seleccionado puede que la orden haya sido preparada y deberas agregar cantidades al producto para nueva seleócion de adicionales.
        </div>
        <Tab.Container defaultActiveKey={data.body[0]?.id}>
          <Row>
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                {data.body.map(category => (
                  <Nav.Item key={category.id}>
                    <Nav.Link eventKey={category.id}>
                      {category.name}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                {data.body.map(category => (
                  <Tab.Pane key={category.id} eventKey={category.id}>
                    <h5 className="mb-3">{category.name}</h5>
                    <Form>
                      {category.values.map(item => [
                        <Form.Check
                          key={item.id}
                          type="checkbox"
                          id={`checkbox-${item.id}`}
                          label={item.table_value}
                          checked={selectedItems[category.id]?.[item.id] || false}
                          onChange={(e) => handleCheckboxChange(
                            category.id,
                            item.id,
                            e.target.checked
                          )}
                          className="mb-2"
                        />,
                        <Form.Control
                            key={`input-${item.id}`}
                            type="number"
                            placeholder='Qty'
                            min="0"
                            max="99"
                            value={selectedItems[category.id]?.[item.id]?.quantity || ''}
                            onChange={(e) => handleQuantityChange(category.id, item.id, e.target.value)}
                            style={{ width: '70px' }}
                            //disabled={!selectedItems[category.id]?.[item.id]?.selected}
                        />
                      ])}
                    </Form>
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
                <label>Nota de artículo</label>
                <textarea 
                  rows={3}
                  className="form-control"
                  placeholder='Agregar comentario artículo'
                  value={fnCommentValue}
                  onChange={(input)=>{
                    fnComment(input.target.value)
                  }}
                ></textarea>
            </Col>
          </Row>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Guardar Selección
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ModalFittings.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func,
    data: PropTypes.any,
    onSave: PropTypes.func,
    fittingData: PropTypes.any,
    fnCommentValue: PropTypes.any,
    fnComment: PropTypes.func
}

const styles = {
  alert: {
    padding: '0.75rem 1rem',
    marginBottom: '1rem',
    border: '1px solid #b6d7ff',
    borderRadius: '0.375rem',
    backgroundColor: '#cff4fc',
    color: '#055160'
  }
};

export default ModalFittings;